import React, {Component} from "react";
import Form from 'react-bootstrap/Form';

export default class ProductsBySwitcher extends Component 
{
    constructor (props)
    {
        super(props);

        this.selectArticul = this.selectArticul.bind(this);
        this.selectName = this.selectName.bind(this);
    }
    selectArticul (e)
    {
        this.props.on_switch('articul');
    }
    selectName (e)
    {
        this.props.on_switch('name');
    }
    render() {
        return (
            <Form className="pt-2 pb-2 pb-md-3">
                <div className="float-md-right">
                    <Form.Check onChange={this.selectArticul} inline custom defaultChecked={'articul' == this.props.value} label="Артикул" type="radio" id="products_by_articul" name="products_by" value="articul" />
                    <Form.Check onChange={this.selectName} inline custom defaultChecked={'name' == this.props.value} label="Наименование" type="radio" id="products_by_name" name="products_by" value="name" />                
                </div>
                <div className="clearfix"></div>
            </Form>
        );
    }
}